export default "__VITE_ASSET__Dt5QYY$4__"